const radioFieldset = document.querySelector("fieldset.radio");
const regionSelect = document.querySelector("select[name='region']");
const sourceSelect = document.querySelector("select[name=where_do_you_listen_0]");
const autoCompleteDiv = document.getElementById("autocomplete");
const podcastSelect = document.querySelector("select[name=where_do_you_listen_2]");
const podcastSpan = podcastSelect.parentElement;
let preselectedPodcast = podcastSelect.value;
let preselectedStation = document.querySelector('fieldset.radio').dataset['stationsSelected'] || null;


// initialize the form on page load
function initializeStationSelect() {

  sourceSelect.value = "Select…";
  autoCompleteDiv.style.display = "none";

  // if initializing following form error
  if (preselectedStation !== null) {
    sourceSelect.value = "Radio";
    hideShowStationSelect();
	autoCompleteDiv.querySelector("input").value = preselectedStation.name;
  }
}

function initializePodcastSelect() {
  podcastSelect.value = preselectedPodcast || "";
  podcastSpan.style.display = "none";
}

function hideShowPodcastSelect() {
  podcastSelect.value = "";
  if (sourceSelect.value === "podcast") {
	podcastSpan.style.display = "block";
  } else {
	podcastSpan.style.display = "none";
  }
}

function hideShowStationSelect() {
  if (sourceSelect.value === 'Radio' && regionSelect.value !== '') {
    autoCompleteDiv.style.display = "block";
  } else if (sourceSelect === 'Radio' && regionSelect.value === '') {
    alert("Please select a 'Region' in the address field.");
  } else {
    autoCompleteDiv.style.display = "none";
	autoCompleteDiv.querySelector("input").value = "";
	document.querySelector("input[name=where_do_you_listen_1]").value = "";
  }
}


// eventListeners
document.addEventListener("DOMContentLoaded", initializeStationSelect);
document.addEventListener("DOMContentLoaded", initializePodcastSelect);
regionSelect.addEventListener("change", initializeStationSelect);
sourceSelect.addEventListener("change", hideShowStationSelect);
sourceSelect.addEventListener("change", hideShowPodcastSelect);






